// Create a simple metrics reducer
import {
  METRICS_FETCH_ERROR,
  METRICS_FETCH_START,
  METRICS_FETCH_SUCCESS,
} from "../thunks/MetricDataDispatcher";

export const ALERT_METRIC = "ALERT_METRIC";
export const CLEAR_ALERT_METRIC = "CLEAR_ALERT_METRIC";

const initialState = {};

export const metricReducer = (state = initialState, action) => {
  switch (action.type) {
    case METRICS_FETCH_START:
      return {
        ...state,
        [action.metricId]: {
          ...state[action.metricId],
          loading: true,
          error: null,
        },
      };
    case METRICS_FETCH_SUCCESS:
      return {
        ...state,
        [action.metricId]: {
          ...action.payload,
          loading: false,
          error: null,
          payload: action.payload,
        },
      };
    case METRICS_FETCH_ERROR:
      return {
        ...state,
        [action.metricId]: {
          ...state[action.metricId],
          loading: false,
          error: action.error,
          payload: null,
        },
      };
    case ALERT_METRIC:
      return {
        ...state,
        [action.metricId]: {
          ...state[action.metricId],
          alert: {
            ...(state[action.metricId] && state[action.metricId].alert
              ? state[action.metricId].alert
              : {}),
            isInAlert: true,
            roles: action.roles || [],
          },
        },
      };
    case CLEAR_ALERT_METRIC:
      return {
        ...state,
        [action.metricId]: {
          ...state[action.metricId],
          alert: {
            ...(state[action.metricId] && state[action.metricId].alert),
            isInAlert: false,
          },
        },
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/mySCC/common/reducers/MetricReducer.js